import { c as t, cB as r, cM as e, cE as o } from "./ghl-ui.es404.js";
import { slideInFromRightTransition as i } from "./ghl-ui.es1363.js";
import { slideInFromLeftTransition as n } from "./ghl-ui.es1364.js";
import { slideInFromTopTransition as a } from "./ghl-ui.es1365.js";
import { slideInFromBottomTransition as d } from "./ghl-ui.es1366.js";
import { fadeInTransition as s } from "./ghl-ui.es1367.js";
const h = t([r("drawer", `
 word-break: break-word;
 line-height: var(--n-line-height);
 position: absolute;
 pointer-events: all;
 box-shadow: var(--n-box-shadow);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 background-color: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 `, [i(), n(), a(), d(), e("unselectable", `
 user-select: none; 
 -webkit-user-select: none;
 `), e("native-scrollbar", [r("drawer-content-wrapper", `
 overflow: auto;
 height: 100%;
 `)]), o("resize-trigger", `
 position: absolute;
 background-color: #0000;
 transition: background-color .3s var(--n-bezier);
 `, [e("hover", `
 background-color: var(--n-resize-trigger-color-hover);
 `)]), r("drawer-content-wrapper", `
 box-sizing: border-box;
 `), r("drawer-content", `
 height: 100%;
 display: flex;
 flex-direction: column;
 `, [e("native-scrollbar", [r("drawer-body-content-wrapper", `
 height: 100%;
 overflow: auto;
 `)]), r("drawer-body", `
 flex: 1 0 0;
 overflow: hidden;
 `), r("drawer-body-content-wrapper", `
 box-sizing: border-box;
 padding: var(--n-body-padding);
 `), r("drawer-header", `
 font-weight: var(--n-title-font-weight);
 line-height: 1;
 font-size: var(--n-title-font-size);
 color: var(--n-title-text-color);
 padding: var(--n-header-padding);
 transition: border .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-divider-color);
 border-bottom: var(--n-header-border-bottom);
 display: flex;
 justify-content: space-between;
 align-items: center;
 `, [o("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), r("drawer-footer", `
 display: flex;
 justify-content: flex-end;
 border-top: var(--n-footer-border-top);
 transition: border .3s var(--n-bezier);
 padding: var(--n-footer-padding);
 `)]), e("right-placement", `
 top: 0;
 bottom: 0;
 right: 0;
 border-top-left-radius: var(--n-border-radius);
 border-bottom-left-radius: var(--n-border-radius);
 `, [o("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 left: 0;
 transform: translateX(-1.5px);
 cursor: ew-resize;
 `)]), e("left-placement", `
 top: 0;
 bottom: 0;
 left: 0;
 border-top-right-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `, [o("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 right: 0;
 transform: translateX(1.5px);
 cursor: ew-resize;
 `)]), e("top-placement", `
 top: 0;
 left: 0;
 right: 0;
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `, [o("resize-trigger", `
 width: 100%;
 height: 3px;
 bottom: 0;
 left: 0;
 transform: translateY(1.5px);
 cursor: ns-resize;
 `)]), e("bottom-placement", `
 left: 0;
 bottom: 0;
 right: 0;
 border-top-left-radius: var(--n-border-radius);
 border-top-right-radius: var(--n-border-radius);
 `, [o("resize-trigger", `
 width: 100%;
 height: 3px;
 top: 0;
 left: 0;
 transform: translateY(-1.5px);
 cursor: ns-resize;
 `)])]), t("body", [t(">", [r("drawer-container", `
 position: fixed;
 `)])]), r("drawer-container", `
 position: relative;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 `, [t("> *", `
 pointer-events: all;
 `)]), r("drawer-mask", `
 background-color: rgba(0, 0, 0, .3);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [e("invisible", `
 background-color: rgba(0, 0, 0, 0)
 `), s({
  enterDuration: "0.2s",
  leaveDuration: "0.2s",
  enterCubicBezier: "var(--n-bezier-in)",
  leaveCubicBezier: "var(--n-bezier-out)"
})])]);
export {
  h as default
};
